import React from 'react';
import './PetAnimations.css';

export default function CamelSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#D4A860';
  const lightColor = color ? lighten(color) : '#E8C888';
  const darkColor = color ? darken(color) : '#B48840';
  const muzzleColor = '#C89848';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path d="M96 50C100 46 102 40 100 38" stroke={darkColor} strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M100 36C100 34 102 34 102 36" stroke={darkColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      {/* Body */}
      <ellipse cx="68" cy="56" rx="30" ry="16" fill={bodyColor} />
      {/* Two humps */}
      <ellipse cx="56" cy="42" rx="10" ry="10" fill={bodyColor} />
      <ellipse cx="80" cy="42" rx="10" ry="10" fill={bodyColor} />
      {/* Hump highlights */}
      <ellipse cx="54" cy="40" rx="6" ry="6" fill={lightColor} opacity="0.4" />
      <ellipse cx="78" cy="40" rx="6" ry="6" fill={lightColor} opacity="0.4" />
      {/* Belly */}
      <ellipse cx="68" cy="62" rx="18" ry="8" fill={lightColor} />
      {/* Long legs */}
      <rect x="46" y="66" width="7" height="26" rx="3" fill={bodyColor} />
      <rect x="56" y="68" width="6" height="24" rx="3" fill={bodyColor} />
      <rect x="76" y="68" width="6" height="24" rx="3" fill={bodyColor} />
      <rect x="86" y="66" width="7" height="26" rx="3" fill={bodyColor} />
      {/* Hooves */}
      <ellipse cx="49.5" cy="93" rx="4.5" ry="2.5" fill={darkColor} />
      <ellipse cx="59" cy="93" rx="4" ry="2.5" fill={darkColor} />
      <ellipse cx="79" cy="93" rx="4" ry="2.5" fill={darkColor} />
      <ellipse cx="89.5" cy="93" rx="4.5" ry="2.5" fill={darkColor} />
      {/* Neck (long) */}
      <path d="M44 52C36 48 28 38 26 28" fill={bodyColor} />
      <path d="M38 54C30 50 24 40 22 30" fill={bodyColor} />
      <rect x="22" y="28" width="22" height="26" rx="8" fill={bodyColor} />
      {/* Head */}
      <ellipse cx="26" cy="26" rx="14" ry="12" fill={bodyColor} />
      {/* Muzzle */}
      <ellipse cx="18" cy="30" rx="8" ry="6" fill={muzzleColor} />
      {/* Ears (small) */}
      <ellipse cx="20" cy="16" rx="3" ry="5" fill={bodyColor} />
      <ellipse cx="32" cy="16" rx="3" ry="5" fill={bodyColor} />
      <ellipse cx="20" cy="16" rx="2" ry="3.5" fill="#E8A0A0" />
      <ellipse cx="32" cy="16" rx="2" ry="3.5" fill="#E8A0A0" />
      {/* Eyes (droopy, half-closed) */}
      <ellipse cx="20" cy="24" rx="3.5" ry="2.5" fill="white" />
      <ellipse cx="30" cy="24" rx="3.5" ry="2.5" fill="white" />
      <circle cx="21" cy="24" r="1.8" fill="#4A3420" />
      <circle cx="31" cy="24" r="1.8" fill="#4A3420" />
      <circle cx="21.5" cy="23.5" r="0.7" fill="white" />
      <circle cx="31.5" cy="23.5" r="0.7" fill="white" />
      {/* Droopy eyelids */}
      <path d="M16 23C18 22 22 22 24 23" stroke={bodyColor} strokeWidth="2" fill={bodyColor} />
      <path d="M26 23C28 22 32 22 34 23" stroke={bodyColor} strokeWidth="2" fill={bodyColor} />
      {/* Nostrils */}
      <circle cx="14" cy="29" r="1.5" fill={darkColor} />
      <circle cx="18" cy="29" r="1.5" fill={darkColor} />
      {/* Mouth (slight smile) */}
      <path d="M14 34C16 35 20 35 22 34" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
